export default __webpack_public_path__ + "static/media/Grow-your-community.c250c469.jpg";